import { render } from "./OrderKitForm.vue?vue&type=template&id=5f1e7f09"
import script from "./OrderKitForm.vue?vue&type=script&lang=js"
export * from "./OrderKitForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__